import { useEffect } from "react";
import { useMap } from "react-leaflet";

// Flies once per new `position` object. (It used to call flyTo during render, so *any*
// re-render of the app — e.g. typing in the search box — restarted the animation.)
export default function FlyToPosition({ position, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (!position) return;
    map.flyTo(position, Math.max(map.getZoom(), zoom), { duration: 1.5 });
  }, [position]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
